/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { RetornoDSSapType } from '../models/retorno-dssap-type';
import { RequestDSSapType } from '../models/request-dssap-type';
import { Message } from '../models/message';
import { RequestCancelamentoSAPType } from '../models/request-cancelamento-saptype';
import { RequestAlteracaoDataParcelaSAPType } from '../models/request-alteracao-data-parcela-saptype';
import { Parcela } from '../models/parcela';

/**
 * API responsavel pela integracao com o SAP
 */
@Injectable({
  providedIn: 'root',
})
class SAPService extends __BaseService {
  static readonly obterParcelasSAPPath = '/sap';
  static readonly cancelarContratoSAPPath = '/sap-cancelamento-contrato';
  static readonly alterarDataVencimentoParcelaSAPPath = '/sap-alterar-data-vencimento-parcela';
  static readonly simularAlteracaoDataVencimentoParcelaSAPPath = '/sap-alterar-data-vencimento-parcela/simular';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera todos os registros de parcelas do SAP DS
   * @param request Objeto de entrada para buscar as parcelas no DS
   * @return Operacao realizada com sucesso
   */
  obterParcelasSAPResponse(request: RequestDSSapType): __Observable<__StrictHttpResponse<Array<RetornoDSSapType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/sap`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<RetornoDSSapType>>;
      })
    );
  }
  /**
   * Recupera todos os registros de parcelas do SAP DS
   * @param request Objeto de entrada para buscar as parcelas no DS
   * @return Operacao realizada com sucesso
   */
  obterParcelasSAP(request: RequestDSSapType): __Observable<Array<RetornoDSSapType>> {
    return this.obterParcelasSAPResponse(request).pipe(
      __map(_r => _r.body as Array<RetornoDSSapType>)
    );
  }

  /**
   * Cancela um contrato financeiro no SAP
   *
   * Efetua o cancelamento de um contrato financeiro
   * @param idAcordo Codigo do acordo a ser cancelado
   * @return Operacao realizada com sucesso
   */
  cancelarContratoSAPResponse(idAcordo: RequestCancelamentoSAPType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = idAcordo;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/sap-cancelamento-contrato`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Cancela um contrato financeiro no SAP
   *
   * Efetua o cancelamento de um contrato financeiro
   * @param idAcordo Codigo do acordo a ser cancelado
   * @return Operacao realizada com sucesso
   */
  cancelarContratoSAP(idAcordo: RequestCancelamentoSAPType): __Observable<Message> {
    return this.cancelarContratoSAPResponse(idAcordo).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Cancela um contrato financeiro no SAP
   *
   * Efetua o cancelamento de um contrato financeiro
   * @param idAcordo Codigo do acordo a ser cancelado
   * @return Operacao realizada com sucesso
   */
  alterarDataVencimentoParcelaSAPResponse(idAcordo: RequestAlteracaoDataParcelaSAPType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = idAcordo;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/sap-alterar-data-vencimento-parcela`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Cancela um contrato financeiro no SAP
   *
   * Efetua o cancelamento de um contrato financeiro
   * @param idAcordo Codigo do acordo a ser cancelado
   * @return Operacao realizada com sucesso
   */
  alterarDataVencimentoParcelaSAP(idAcordo: RequestAlteracaoDataParcelaSAPType): __Observable<Message> {
    return this.alterarDataVencimentoParcelaSAPResponse(idAcordo).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Simula a alteracao de uma parcela no SAP
   *
   * Simula a alteracao da data de vencimento de uma parcela
   * @param requestAlteracaoParcela Informacoes da parcela
   * @return Operacao realizada com sucesso
   */
  simularAlteracaoDataVencimentoParcelaSAPResponse(requestAlteracaoParcela: RequestAlteracaoDataParcelaSAPType): __Observable<__StrictHttpResponse<Parcela>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = requestAlteracaoParcela;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/sap-alterar-data-vencimento-parcela/simular`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Parcela>;
      })
    );
  }
  /**
   * Simula a alteracao de uma parcela no SAP
   *
   * Simula a alteracao da data de vencimento de uma parcela
   * @param requestAlteracaoParcela Informacoes da parcela
   * @return Operacao realizada com sucesso
   */
  simularAlteracaoDataVencimentoParcelaSAP(requestAlteracaoParcela: RequestAlteracaoDataParcelaSAPType): __Observable<Parcela> {
    return this.simularAlteracaoDataVencimentoParcelaSAPResponse(requestAlteracaoParcela).pipe(
      __map(_r => _r.body as Parcela)
    );
  }
}

module SAPService {
}

export { SAPService }
